import { render } from "./CallbackModal.vue?vue&type=template&id=4753b8e6&scoped=true"
import script from "./CallbackModal.vue?vue&type=script&lang=js"
export * from "./CallbackModal.vue?vue&type=script&lang=js"

import "./CallbackModal.vue?vue&type=style&index=0&id=4753b8e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4753b8e6"]])

export default __exports__